import styled from "styled-components";

export const PortFolioStyles = styled.section.attrs(props => ({
    id: props.id,
}))`

    padding: 8rem 0 0;
    min-height: 100vh;

    & .portfolio__item {
        flex: 0 0 33.33%;
        max-width: 33.33%;
        padding: 1.5rem;
        display: flex;
        flex-wrap: wrap;

        &:not(:last-child) {
            @media screen and (max-width: 1000px) {
             margin-bottom: 10rem;
            }
        }

        @media screen and (max-width: 1000px) {
            flex: 0 0 80%;
            max-width: 80%;
            margin: auto;
        }

        & .portfolio__item--inner {
            width: 100%;
            padding: 1.5rem;
            border-radius: 5px;
            cursor: pointer;

            & .portfolio__item--title {
                font-size: 1.6rem;
                font-weight: 600;
                margin: 10px 0 0;
                color: var(--color-text);
                text-transform: capitalize;
            }

            & .portfolio__item--img {
                position: relative;

                & img {
                    width: 100%;
                    border-radius: 5px;
                    transition: all .3s ease;
                }

                & .view__btn {
                    position: absolute;
                    left: 0;
                    bottom: -4px;
                    transform: translateY(-5px);
                    font-size: 1.6rem;
                    text-transform: capitalize;
                    color: var(--color-primary-dark);
                    font-weight: 500;
                    transition: all .3s ease;
                    opacity: 0;
                    z-index: -1;
                }
            }
        }

        & .portfolio__item--inner:hover .view__btn {
            transform: translateY(0);
            opacity: 1;
        }

        & .portfolio__item--inner:hover .portfolio__item--img img {
            transform: translateY(-25px);
        }

        & .portfolio__item--details {
            display: none;
        }
    }

`;